import { render } from "./CustomerSettings.vue?vue&type=template&id=5d836180"
import script from "./CustomerSettings.vue?vue&type=script&lang=js"
export * from "./CustomerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__